import { useRegisterSW } from 'virtual:pwa-register/react'
import { RefreshCw } from 'lucide-react'

/**
 * Subtle "new version available" toast. vite-plugin-pwa wires the SW lifecycle;
 * with registerType:'prompt' we ask before reloading so we never interrupt a
 * Storm-Mode session mid-event.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl) {
      // eslint-disable-next-line no-console
      console.info('[pwa] service worker registered:', swUrl)
    },
    onRegisterError(err) {
      // eslint-disable-next-line no-console
      console.error('[pwa] SW registration error', err)
    },
  })

  if (!needRefresh) return null

  return (
    <div className="update-toast" role="status">
      <RefreshCw size={16} />
      <span>New version available</span>
      <button className="update-toast__btn" onClick={() => updateServiceWorker(true)}>
        Reload
      </button>
      <button className="update-toast__dismiss" aria-label="Dismiss" onClick={() => setNeedRefresh(false)}>
        ✕
      </button>
    </div>
  )
}
